import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    CCard,
    CCardBody,
    CCol,
    CRow,
    CLabel,
    CSelect,
    CInput,
    CInputGroup,
    CContainer,
    CModalFooter,
    CModalBody,
    CModalHeader,
    CModal,

    CModalTitle,
    CButton,
} from "@coreui/react";
import moment from "moment"
import Attachments from "src/components/attachments/Attachments";
import { getPamentFromLedgerList, getPamentToLedgerList, getDoubleEntryPaymentLedgerList, createPayment, getBillRefByLedgerId, checkDupilcateBillRefNo, createSaleAccountingInvoice, createPurchase } from "src/actions/cash-payments";
import { Field, FieldArray, Form, Formik } from "formik";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { AutoComplete } from 'primereact/autocomplete';
import * as Yup from "yup"
import { numFormatter } from "src/util/to-local-string/numberFormatter";
import { useLocation } from "react-router-dom";
import ToastMessage from "src/components/toast-message/ToastMessage";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import EmptyMessage from "src/util/data-table-empty-message/emptyMessage";
import { CREATE_PAYMENT_DONE, CREATE_PAYMENT_INIT } from "src/actions/actionTypes";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField, Tooltip } from "@material-ui/core";
import { getPurchaseGroupList } from "src/actions/purchase";
import cookie from "react-cookies"
import { getUserName } from "src/util/miscUtil";
import { globalApiUrl } from "src/util/globalUrls";


const PurchaseAdd = (props) => {
    const { popup, pathType } = props
    const [primary, setPrimary] = useState(false);
    const [AdditionaldetailsModal, setAdditionaldetailsModal] = useState(false);
    const [paymentMode, setpaymentMode] = useState("-1")
    const [allAdditionalDetails, setallAdditionalDetails] = useState("")
    const [insNo, setinsNo] = useState("")
    const [insDate, setinsDate] = useState("")
    const ledgerListForDoubleEntry = useSelector((state) => state?.cashPaymentsReducer?.ledgerListForDoubleEntry);
    // const ledgerListForDoubleEntry = useSelector((state) => state ?.cashPaymentsReducer ?.ledgerListForDoubleEntry);
    const paymentMadeToLedgerList = useSelector((state) => state?.cashPaymentsReducer?.paymentMadeToLedgerList);
    const billRefByLedger = useSelector((state) => state?.cashPaymentsReducer?.billRefByLedger);
    const paymentSaveStatus = useSelector((state) => state?.paymentReducer?.paymentSaveStatus);
    const purchaseGroupList = useSelector((state) => state?.purchaseReducer?.purchaseGroupList);
    const dispatch = useDispatch()
    const [showtotalbillEntryValue, setshowtotalbillEntryValue] = useState()
    const [showLederOnBillEntryModal, setshowLederOnBillEntryModal] = useState()
    const [billRefList, setbillRefList] = useState([
        { list: [] }
    ])
    const validationSchema = Yup.object().shape({
        paymentMadeFrom: Yup
            .string()
            .required("This field is required"),
        vocherLedgerList: Yup.array()
            .of(
                Yup.object().shape({
                    amount: Yup.string().required("Amount is required"),
                    ledger: Yup.string().required("Please select ledger"),
                })
            )
    });
    const [intialValues, setintialValues] = useState()

    const validationSchemaForBreakUp = Yup.object().shape({
        billwiseDetails: Yup.array()
            .of(
                Yup.object().shape({
                    amount: Yup.string().required("Amount is required"),
                    typeOfRef: Yup.string().required("Please select ref. type"),
                    name: Yup.string().required("Name is required"),
                    // dueDate: Yup.string().required("Please select due date"),
                    amountType: Yup.string().required("Please select amount type"),
                    duplicate: Yup.mixed().oneOf([0], "Name already exist")
                })
            )
    });
    useEffect(() => {
        // dispatch(getPamentFromLedgerList())
        // dispatch(getPamentToLedgerList())
        dispatch(getDoubleEntryPaymentLedgerList())
        dispatch({
            type: CREATE_PAYMENT_INIT,
        });
    }, [])

    useEffect(() => {
        if (paymentSaveStatus == 2) {
            settoastMeg("Success")
            setshowToastSuccess(true);
            setTimeout(() => {
                setshowToastSuccess(false);
            }, 1000);
            dispatch({
                type: CREATE_PAYMENT_DONE,
            });

        }

    }, [paymentSaveStatus])

    const [totalValue, settotalValue] = useState(0)

    const onSaveClick = (values, billDetailArr, billTotal) => {
        setshowToast(false)
        setshowToastSuccess(false)
        let vocherLedgerArray = []
        let vocherRefList = []
        let billArr = billDetailArr
        if (billArr && billArr.length > 0) {
            billArr.forEach(e => {
                let data = {
                    "ledgerEntryId": 0,
                    "ledgerId": values.paymentMadeFrom,
                    "refAmount": e.amount,
                    "refAmountType": e.amountType,
                    "refDate": e.dueDate,
                    "refId": 0,
                    "refName": e.name,
                    "refType": e.typeOfRef
                }
                vocherRefList.push(data)
            })
        }
        if (values.vocherLedgerList.length > 0) {
            values.vocherLedgerList.forEach((e) => {

                let data = {
                    "createdBy": getUserName(),
                    "ledgerId": e.ledger,
                    "vocLedAmount": e.amount,
                    "vocLedRefNo": e.billRefNo,
                    "vocLedType": pathType != "Sales" ? "Dr" : "Cr",
                    "vocherId": 0,
                }
                vocherLedgerArray.push(data)
            })
        }
        const data = {
            "createdBy": getUserName(),
            "effetiveDate": null,
            "invocieDate": null,
            "ledgerId": values.paymentMadeFrom,
            "paymentEntryType": "Accounting Invoice",
            "supplierNumber": values.suppInvoiceNo,
            "tallyGuid": "",
            "vocherLedgerList": vocherLedgerArray,
            "vocherNarration": values.narration,
            // "vocherPaymentMode": "string",
            "vocherRefList": vocherRefList,
            "vocherTransactionDate": values.transactionDate,
            "vocherType": purchaseType,
            "entryFrom": "WEB"
            // "vocherTypeId": 0
        }
        if (billDetailArr.length > 0 && billTotal != totalValue) {
            settoastMeg("Amount Mismatch")
            setshowToast(true)
        } else {
            if (pathType == "Sales") {
                dispatch(createSaleAccountingInvoice(data))
            } else {
                dispatch(createPurchase(data))
            }
            setshowToastSuccess(true)
            settoastMeg("Saved successfully")
            onMainModalClose()
        }
    }


    const optionTemplate = () => {
        return (
            purchaseGroupList && purchaseGroupList.map((data, i) => {
                return (
                    <option key={i}>{data.voucherType}</option>
                )
            })
        )
    }
    const onAmountChange = (values, i, value, billwiseDetailsArray, setFieldValue) => {
        let field = setFieldValue
        claculateTotalAmount(values, i, value, field)
        let amt = 0
        let narration = []
        let narrToString = ""
        if (values && values.length > 0) {
            let att = [...values]
            // att.splice(i, 1)
            att[i]['amount'] = value
            if (att && att.length > 0) {
                att.forEach(element => {
                    amt += Number(element.amount)
                    narration.push(element.ledgerName)
                });
            }
            // amt = Number(amt) + Number(value)
            narrToString = narration.toString()
        }
        if (amt != 0 && narrToString != "") {
            setFieldValue(`narration`, `Being payment of Rs. ${amt} made to ${narrToString}`)
        }
    }

    const claculateTotalAmount = (values, i, value, billwiseDetailsArray, setFieldValue) => {
        let amt = 0
        let narration = []
        let narrToString = ""
        if (values && values.length > 0) {
            let att = [...values]
            att.splice(i, 1)
            if (att && att.length > 0) {
                att.forEach(element => {
                    amt += Number(element.amount)
                    narration.push(element.ledgerName)
                });
            }
            amt = Number(amt) + Number(value)
            settotalValue(amt)
        }
    }

    const [transactionDateValue, settransactionDateValue] = useState(new Date())
    const [dueDateValue, setdueDateValue] = useState()
    const [instumentDateValue, setinstumentDateValue] = useState("")
    const [selectedFromLedger, setselectedFromLedger] = useState("");
    const [selectedToLedgerListData, setselectedToLedgerListData] = useState([{
        selectedValue: {},
        selectedBillRef: "",
        selectedAmount: {}
    }]);
    const [selecteddateValue, setselecteddateValue] = useState([
        {
            selectedDueDateValue: ""
        }
    ]);
    const [setNarrationValue, setsetNarrationValue] = useState()
    const onLedgerChange = (e, newVal, i, list, setFieldValue, billList, billwiseDetailsArray, values) => {
        let contryies = list
        let conuntry = contryies[i]
        conuntry['selectedValue'] = newVal ?? {}
        contryies[i] = conuntry
        setselectedToLedgerListData(contryies)
        setFieldValue(`vocherLedgerList.${i}.ledger`, newVal ? newVal.ledgerId : '')
        setFieldValue(`vocherLedgerList.${i}.ledgerName`, newVal ? newVal.ledgerName : '')
        let ledgerNames = []
        if (values && values.length > 0) {
            let arr = [...values]
            arr.splice(i, 1)
            if (arr && arr.length > 0) {
                arr.forEach(element => {
                    ledgerNames.push(element.ledgerName)
                });
            }
            if (newVal) {
                ledgerNames.push(newVal.ledgerName)
            }
        }
        let ledgerNameAsString = ledgerNames.toString()
        setsetNarrationValue(ledgerNameAsString)
        if (totalValue != 0) {
            setFieldValue(`narration`, `Being payment of Rs. ${totalValue} made to ${ledgerNameAsString}`)
        }
    }
    const [closingBalanceValue, setclosingBalanceValue] = useState(0)
    const onFromledgerChange = (ev, setFieldValue) => {
        setFieldValue('paymentMadeFrom', ev.value.ledgerId)
        setselectedFromLedger(ev.value)
        dispatch(getBillRefByLedgerId(ev.value.ledgerId, "Agst Ref"))
        setbillwiseDetailsArray([])
    }
    const selectedCountryTemplate = (option, props) => {
        if (option) {
            return (
                <div className="country-item country-item-value">
                    <div>{option.ledgerName}</div>
                </div>
            );
        }
        return (
            <span>
                {props.placeholder}
            </span>
        );
    }

    const selectedToledgerTemplate = (option, props) => {
        if (option) {
            return (
                <div className="country-item country-item-value">
                    <div>{option.ledgerName}</div>
                </div>
            );
        }
        return (
            <span>
                {props.placeholder}
            </span>
        );
    }

    const countryOptionTemplate = (option) => {
        return (
            <div className="country-item">
                <div>{option.ledgerName}</div>
            </div>
        );
    }
    const toLedgerOptionTemplate = (option) => {
        return (
            <div className="country-item">
                <div>{option.ledgerName}</div>
            </div>
        );
    }

    const onAddBreakUpAmounts = (push, list) => {
        push({
            typeOfRef: "Advance",
            name: "",
            dueDate: "",
            amount: "",
            amountType: "Dr",
            duplicate: 0
            // oldValue:false
        })
        list.push({
            selectedDueDateValue: ""
        })
        setselecteddateValue(list)
    }
    const [setRefIndexForSelectedBill, setsetRefIndexForSelectedBill] = useState()
    const [values, setvalues] = useState()
    const onNameClick = (value, i, values) => {
        if (value == "Agst Ref") {
            setsetRefIndexForSelectedBill(i)
            setvalues(values)
            setprimaryRefModal(!primaryRefModal)
        }
    }
    const onNameInput = (e, values, i, setFieldValue, id) => {
        if (values.billwiseDetails[i].typeOfRef != "Agst Ref") {
            fetch(globalApiUrl + `tallycrudapi/tally/vouchers/checkNewRefNoAlreadyExist?refNo=${e}&ledgerId=${id}`, {
                headers: {
                    Tenant: cookie.load("TENANT"),
                },
            })
                .then((data) => data.json())
                .then((data) => {
                    if (data.count == 1) {
                        setFieldValue(`billwiseDetails.${i}.duplicate`, 1)
                    } else {
                        setFieldValue(`billwiseDetails.${i}.duplicate`, 0)
                    }
                })
        }
    }
    const [amtList, setamtList] = useState([
        { list: [] }
    ])
    const onTypeOfRefChange = (e, setFieldValue, i, values) => {
        setFieldValue(`billwiseDetails.${i}.typeOfRef`, e)
        setFieldValue(`billwiseDetails.${i}.name`, "")
        setFieldValue(`billwiseDetails.${i}.duplicate`, 0)
    }
    const onBtnClick = (push, list, billList, amtList, billWiseList) => {
        push({ ledger: "", amount: "", billRefNo: "", type: "Dr", ledgerName: "" })
        list.push({
            selectedValue: {},
            selectedBillRef: "",
            selectedAmount: {}
        })
        billList.push({
            list: []
        })
        amtList.push({
            list: []
        })
        let billWiseSubList = billWiseList
        billWiseSubList.push([])
        setselectedToLedgerListData(list)
        setbillRefList(billList)
        setamtList(amtList)
        setbillwiseDetailsArray(billWiseSubList)
    }
    const [filteredBillRefNo, setfilteredBillRefNo] = useState(null);
    const onDeleteClick = (remove, i, list, billList, amtList, billwiseDetailsArray, values, setFieldValue) => {
        list.splice(i, 1)
        billList.splice(i, 1)
        amtList.splice(i, 1)
        let arrData = billwiseDetailsArray
        arrData.splice(i, 1)
        remove(i)
        let voLedgerList = values?.vocherLedgerList
        claculateTotalAmount(values?.vocherLedgerList, i, "0", "", setFieldValue)
        let amt = 0
        let narration = []
        let narrToString = ""
        if (voLedgerList && voLedgerList.length > 0) {
            let att = [...voLedgerList]
            att.splice(i, 1)
            if (att && att.length > 0) {
                att.forEach(element => {
                    amt += Number(element.amount)
                    narration.push(element.ledgerName)
                });
            }
            narrToString = narration.toString()
        }
        if (amt != 0 && setNarrationValue != "") {
            setFieldValue(`narration`, `Being payment of Rs. ${amt} made to ${narrToString}`)
        }

    }

    const onBraekUpDeleteClick = (remove, i) => {
        remove(i)
    }
    const onTransactionDateChange = (val, setFieldValue) => {
        settransactionDateValue(val)
        setFieldValue("transactionDate", moment(val).format("YYYY-MM-DD"))
    }
    const onDueDateChange = (val, setFieldValue, index, list) => {
        // setdueDateValue(val)
        setFieldValue(`billwiseDetails.${index}.dueDate`, moment(val).format("YYYY-MM-DD"))
        let lData = list
        let data = lData[index]
        data['selectedDueDateValue'] = val
        lData[index] = data
        setselecteddateValue(lData)
    }
    const onInstumentDateChange = (val, setFieldValue) => {
        setinstumentDateValue(val)
        setFieldValue("instumentDate", moment(val).format("YYYY-MM-DD"))
    }
    const [primaryMain, setPrimaryMain] = useState(true)
    const [primaryRefModal, setprimaryRefModal] = useState(false)
    const onModalClose = () => {
        setintialValues({
            billwiseDetails: []
        })
        setPrimary(!primary)
    }
    const onRefModalClose = () => {
        setprimaryRefModal(!primaryRefModal)
    }
    const [billwiseDetailsTotal, setbillwiseDetailsTotal] = useState("")
    const [billwiseDetailsArray, setbillwiseDetailsArray] = useState([])
    const [billwiseDetailsArrayIndex, setbillwiseDetailsArrayIndex] = useState()
    const onBillWiseDetailsSubmit = (values, array) => {
        let drValue = 0
        let crValue = 0
        let diffValue = 0
        let arrayList = values.billwiseDetails
        arrayList.forEach(e => {
            e.amountType == "Dr" ? drValue += Number(e.amount) : crValue += Number(e.amount)
        })
        diffValue = Number(drValue) - Number(crValue)
        setbillwiseDetailsTotal(diffValue)
        let billArray = array
        billArray = values.billwiseDetails
        setbillwiseDetailsArray(billArray)
        onModalClose()
    }
    // const onBillWiseDetailsSubmit = (values, array, arrayIndex) => {

    //     let drValue = 0
    //     let crValue = 0
    //     let diffValue = 0
    //     let arrayList = values.billwiseDetails
    //     arrayList.forEach(e => {
    //         e.amountType == "Dr" ? drValue += Number(e.amount) : crValue += Number(e.amount)
    //     })
    //     diffValue = Number(drValue) - Number(crValue)
    //     // if (Number(diffValue) == Number(showtotalbillEntryValue)) {
    //         let billArray = array
    //         billArray[arrayIndex] = values.billwiseDetails
    //         setbillwiseDetailsArray(billArray)
    //         onModalClose()
    //     // } else {
    //     //     // alert('Bill amount does not match with Transaction amount')
    //     //     settoastMeg("Bill amount does not match with Transaction amount")
    //     //     setshowToast(true)
    //     //     setTimeout(() => {
    //     //         setshowToast(false)
    //     //     }, 3000)
    //     // }

    // }

    const [selectedLedgerId, setselectedLedgerId] = useState()
    // const onModalOpen = (i, array, setFieldValue, ledgerId, amount) => {
    //     setshowtotalbillEntryValue(amount)
    //     let data = paymentMadeToLedgerList.filter(e => e.ledgerId == ledgerId)
    //     setshowLederOnBillEntryModal(data[0].ledgerName)
    //     setselectedLedgerId(ledgerId)
    //     setbillwiseDetailsArrayIndex(i)
    //     if (array[i] && array[i].length == 0) {
    //         setintialValues({
    //             billwiseDetails: [
    //                 {
    //                     typeOfRef: "Advance",
    //                     name: "",
    //                     dueDate: "",
    //                     amount: amount,
    //                     amountType: "Dr",
    //                     duplicate: 0
    //                     // ledgerId: ledgerId
    //                 }
    //             ]
    //         })
    //         setselecteddateValue([
    //             {
    //                 selectedDueDateValue: ""
    //             }
    //         ]);
    //     } else {
    //         let arr = []
    //         let loopArr = array
    //         loopArr.forEach((e, i) => {
    //             arr.push(e)
    //         })
    //         const data = { billwiseDetails: loopArr[i] }
    //         let dateValue = []
    //         data.billwiseDetails.forEach(e => {
    //             let dateData = {
    //                 selectedDueDateValue: new Date(e.dueDate)
    //             }
    //             dateValue.push(dateData)
    //         })
    //         setselecteddateValue(dateValue)
    //         setintialValues(data)
    //     }

    //     setPrimary(!primary)
    // }

    const onModalOpen = (array, values) => {
        setselectedLedgerId(values.paymentMadeFrom)
        if (array.length == 0) {
            setintialValues({
                billwiseDetails: [
                    {
                        typeOfRef: "Advance",
                        name: "",
                        dueDate: "",
                        amount: "",
                        amountType: "Dr",
                        duplicate: 0
                    }
                ]
            })
            setselecteddateValue([
                {
                    selectedDueDateValue: ""
                }
            ]);
        } else {
            let loopArr = array

            const data = { billwiseDetails: loopArr }
            let dateValue = []
            data.billwiseDetails.forEach(e => {
                let dateData = {
                    selectedDueDateValue: new Date(e.dueDate)
                }
                dateValue.push(dateData)
            })
            setselecteddateValue(dateValue)
            setintialValues(data)
        }

        setPrimary(!primary)
    }

    const [showToastSuccess, setshowToastSuccess] = useState(false)
    const [showToast, setshowToast] = useState(false)
    const [toastMeg, settoastMeg] = useState("")
    const [globalFilter, setGlobalFilter] = useState();
    const header = () => {
        return (
            <div className="input-fields mb-2">

                <span className="p-input-icon-right">
                    {/* <i className="pi pi-search" /> */}
                    <input
                        type="text"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Global Search"
                        className="p-inputtext p-component form-control"
                        id=""
                        // size="30"
                        autoFocus
                    />
                </span>
            </div>
        );
    };
    const onSelectData = (data, index) => {
        const val = values
        const indexWiseData = val.billwiseDetails[setRefIndexForSelectedBill]
        indexWiseData['name'] = data.refNo
        indexWiseData['dueDate'] = data.date
        indexWiseData['amount'] = data.balance
        indexWiseData['amountType'] = data.tyupe
        val.billwiseDetails[index] = indexWiseData
        setintialValues(val)
        let date = selecteddateValue
        date[setRefIndexForSelectedBill]['selectedDueDateValue'] = new Date(data.date)
        setselecteddateValue(date)
        setprimaryRefModal(!primaryRefModal)
    }
    const onMainModalClose = () => {
        settoastMeg(false)
        setPrimaryMain(!primaryMain)
    }

    const onAdditionalSave = () => {
        const data = {
            paymentMode: paymentMode,
            insNo: insNo,
            insDate: insDate

        }
        setallAdditionalDetails([data])
        onAdditionalModalClose()
    }
    const onAdditionalModalOpen = (allAdditionalDetails) => {
        if (allAdditionalDetails.length == 0) {
            setpaymentMode("")
            setinsNo("")
            setinsDate("")
        }
        setAdditionaldetailsModal(!AdditionaldetailsModal)
    }
    const onAdditionalModalClose = () => {
        setAdditionaldetailsModal(!AdditionaldetailsModal)
    }
    const onParentPurChaseTypeChange = (val) => {
        setpurchaseType(val)
    }
    const [page, setpage] = useState("")
    const [purchaseType, setpurchaseType] = useState("")
    useEffect(() => {
        setpurchaseType(purchaseGroupList[0]?.voucherType)
    }, [purchaseGroupList])
    useEffect(() => {
        if (pathType == "Sales") {
            dispatch(getPurchaseGroupList("Sales"))
            setpage("Sales")
        } else {
            dispatch(getPurchaseGroupList("Purchase"))
            setpage("Purchase")
        }
        setpurchaseType(purchaseGroupList[0]?.voucherType)
    }, [pathType])
    return (
        <>
            {showToast && (
                <ToastMessage
                    severity="info"
                    summary="info"
                    detail={toastMeg}
                />
            )}
            {showToastSuccess && (
                <ToastMessage
                    severity="success"
                    summary="Success"
                    detail={toastMeg}
                />
            )}
            <Formik
                initialValues={
                    {
                        paymentMadeFrom: "",
                        suppInvoiceNo: "",
                        transactionDate: moment().format("YYYY-MM-DD"),
                        paymentMode: "",
                        instumentNo: "",
                        instumentDate: null,
                        closingBalance: "",
                        narration: "",
                        vocherLedgerList: [
                            {
                                ledger: "",
                                amount: "",
                                billRefNo: "",
                                type: "Dr",
                                ledgerName: ""

                            }
                        ]
                    }
                }
                validationSchema={validationSchema}
                onSubmit={((values, errors) => {
                    onSaveClick(values, billwiseDetailsArray, billwiseDetailsTotal)
                })}>
                {({ handleChange, values, errors, touched, getFieldProps, handleBlur, setFieldValue }) => (
                    <Form>


                        <CModal
                            show={primaryMain}
                            centered
                            size=""
                            onClose={() => onMainModalClose()}
                            color="dark"
                            closeOnBackdrop={false} className="left"
                        >

                            <div class="modal-header p-3 d-block new-close-button">
                                <h4 class="modal-title">
                                    <div className="row">
                                        <div className="col-md-12 text-center"><h5 className="bold-label mb-0">Create {pathType == "Sales" ? "Sales" : "Purchase"}</h5></div>
                                    </div></h4>
                                <button type="button" class="close" data-dismiss="modal" onClick={() => onMainModalClose()}>&times;</button>
                            </div>
                            <CModalBody className="text-left less-modal-bold pl-2 pr-2 pt-0 pb-2">
                                <div className="card-style-border-top border-0 c-default-layout flex-row align-items-">
                                    <CRow className="justify-content-center">
                                        <CCol xl="12" lg="12" md="12" sm="12">
                                            <CCard className="border-0 mb-1">
                                                <CCardBody className="pl-2 pr-2 pt-0 pb-0">
                                                    <div className="less-modal-bold form-starts">
                                                        <div className="row bg-modal-cash mb-2">
                                                            <div className="col-md-12 mb-0">
                                                                <CRow className="mt-2">
                                                                    <CCol xl="6" lg="6" md="6" xs="12" className="mb-2">
                                                                        <CLabel className="bold-label mb-1">Type</CLabel>
                                                                        <CSelect type="text" placeholder="Priority" name="priority" onChange={(e) => onParentPurChaseTypeChange(e.target.value)} className="text-input-sm">
                                                                            {optionTemplate()}
                                                                        </CSelect>
                                                                    </CCol>

                                                                    <CCol xl="6" lg="6" md="6" xs="12" className="mb-2 pl-0 mobile-no-pad-left">
                                                                        <CLabel className="bold-label mb-1">Date</CLabel>
                                                                        <CInputGroup className="mb-0 calendar-input d-grid">
                                                                            <Calendar
                                                                                id="range"
                                                                                value={transactionDateValue}
                                                                                onChange={(e) => onTransactionDateChange(e.value, setFieldValue)}
                                                                                placeholder="DD/MM/YYYY"
                                                                                dateFormat="dd/mm/yy"
                                                                            />
                                                                        </CInputGroup>
                                                                    </CCol>
                                                                    <CCol xl="6" lg="6" md="6" xs="12" className="mb-2">
                                                                        <CLabel className="bold-label mb-1">Party   {values?.paymentMadeFrom && <Tooltip title="Add Bill Details" arrow><span type="button" onClick={() => onModalOpen(billwiseDetailsArray, values)} className="text-info"><i className="fas fa-info-circle"></i></span></Tooltip>}

                                                                            {!values?.paymentMadeFrom && <span type="button" className="text-muted"><i className="fas fa-info-circle" disabled></i></span>}
                                                                        </CLabel>
                                                                        <div className="single-entry-input">
                                                                            <Dropdown className="" value={selectedFromLedger} name="paymentMadeFrom" options={ledgerListForDoubleEntry} onChange={(e) => onFromledgerChange(e, setFieldValue)} optionLabel="ledgerName" filter filterBy="ledgerName" placeholder="Select Ledger"
                                                                                valueTemplate={selectedCountryTemplate} itemTemplate={countryOptionTemplate} />
                                                                        </div>
                                                                        {errors.paymentMadeFrom && touched.paymentMadeFrom && (<div className="field-error error text-danger">
                                                                            {errors.paymentMadeFrom}
                                                                        </div>)}
                                                                    </CCol>
                                                                    <CCol xl="6" lg="6" md="6" xs="12" className="mb-2 pl-0 mobile-no-pad-left">
                                                                        <CLabel className="bold-label mb-1">{pathType != "Sales" ? "Supplier Invoice No" : "Invoice No"}</CLabel>
                                                                        <CInput type="text" placeholder={pathType != "Sales" ? "Supplier Invoice No" : "Invoice No"} name="suppInvoiceNo" onChange={handleChange} onBlur={handleBlur} className="text-input-sm border-r-b"></CInput>
                                                                        {errors.suppInvoiceNo && touched.suppInvoiceNo && (<div className="field-error error text-danger">
                                                                            {errors.suppInvoiceNo}
                                                                        </div>)}
                                                                    </CCol>
                                                                </CRow>
                                                            </div>
                                                            {<div className="col-md-12 mb-2 text-center">
                                                                {(totalValue != 0 && !isNaN(totalValue)) && <div className="cash-payment-view">
                                                                    <label className="mb-0 mt-1">Total Amount (inr)</label>
                                                                    {(totalValue && totalValue != 0) && <h3 className="dashboard-text-t-amount mb-0">{totalValue ? numFormatter(totalValue) : ""}</h3>}
                                                                </div>}
                                                            </div>}
                                                        </div>
                                                        <FieldArray
                                                            name="vocherLedgerList"
                                                            render={({ remove, push }) => (
                                                                <div>
                                                                    <div className="mt-1 row">
                                                                        <div className="col-md-6 mt-1">
                                                                            <label className="bold-label mb-0">{pathType == "Sales" ? "Sales Ledgers" : "Purchase Ledgers"}</label>
                                                                        </div>
                                                                        <div className="col-md-6 text-right">
                                                                            <Tooltip title="Add" arrow><button type="button" className="btn btn-link text-primary bold-label btn-xs" onClick={() => onBtnClick(push, selectedToLedgerListData, billRefList, amtList, billwiseDetailsArray)}><i className="fa fa-plus"></i></button></Tooltip>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <table className="table mt-0 mb-0 credit-debit-table no-total-border light-td-border mui-input-opt">
                                                                                <thead className=" dark-th-border">
                                                                                    <tr className="un-border">
                                                                                        {/* <th className="min-font-size dashed-left-bottom" width="5%">#</th> */}
                                                                                        <th className="min-font-size dashed-left-bottom light-font-weight pl-0" width="50%">Ledger</th>
                                                                                        <th className="min-font-size dashed-left-bottom light-font-weight" width="30%">Amount</th>
                                                                                        <th className="min-font-size dashed-left-bottom light-font-weight text-right pr-0" width="20%">Action</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {values?.vocherLedgerList?.length > 0 &&
                                                                                        values?.vocherLedgerList.map((voucher, index) => (
                                                                                            <tr key={`vocherLedgerList${index}`} className="un-border">
                                                                                                {/* <td className="dashed-left-bottom table-inside bold-label v-lign-middle"><span className="bold-label">{index + 1}</span></td> */}
                                                                                                <td className="dashed-left-bottom table-inside mui-input pl-0 bold-label v-lign-middle single-entry-input">

                                                                                                    <Autocomplete
                                                                                                        id="combo-box-demo"
                                                                                                        options={ledgerListForDoubleEntry}
                                                                                                        getOptionLabel={(option) => option?.ledgerName ?? ""}
                                                                                                        name={`vocherLedgerList.${index}.ledger`}
                                                                                                        title={selectedToLedgerListData[index]?.selectedValue?.ledgerName}
                                                                                                        value={selectedToLedgerListData[index]?.selectedValue}
                                                                                                        onChange={handleChange, (e, newVal) => onLedgerChange(e, newVal, index, selectedToLedgerListData, setFieldValue, billRefList, billwiseDetailsArray, values?.vocherLedgerList)}
                                                                                                        renderInput={(params) => <TextField {...params} placeholder="select ledger" variant="outlined" className="form-control text-input-sm text-right text-input-sm text-right" />}
                                                                                                    />
                                                                                                    {/* <Dropdown className="" name={`vocherLedgerList.${index}.ledger`} value={selectedToLedgerListData[index] ?.selectedValue} options={paymentMadeToLedgerList} onChange={handleChange,(e) => onLedgerChange(e, index, selectedToLedgerListData, setFieldValue, billRefList,billwiseDetailsArray, values?.vocherLedgerList)} optionLabel="ledgerName" filter filterBy="ledgerName" placeholder="Select Payee"
                                                                                                    valueTemplate={selectedToledgerTemplate} itemTemplate={toLedgerOptionTemplate} onBlur={handleBlur}/> */}
                                                                                                    {errors &&
                                                                                                        errors.vocherLedgerList &&
                                                                                                        errors.vocherLedgerList[index] &&
                                                                                                        errors.vocherLedgerList[index].ledger &&
                                                                                                        touched &&
                                                                                                        touched.vocherLedgerList &&
                                                                                                        touched.vocherLedgerList[index] &&
                                                                                                        touched.vocherLedgerList[index].ledger && (
                                                                                                            <div className="field-error error text-danger">
                                                                                                                {errors.vocherLedgerList[index].ledger}
                                                                                                            </div>
                                                                                                        )}
                                                                                                </td>

                                                                                                <td className="text-right dashed-left-bottom table-inside bold-label v-lign-middle text-primary">

                                                                                                    <Field type="text" placeholder="Enter Amount"
                                                                                                        className="text-input-sm text-right form-control"
                                                                                                        name={`vocherLedgerList.${index}.amount`}
                                                                                                        onInput={(e) => onAmountChange(values?.vocherLedgerList, index, e.target.value, billwiseDetailsArray, setFieldValue)}
                                                                                                        onChange={handleChange}
                                                                                                    ></Field>
                                                                                                    {errors &&
                                                                                                        errors.vocherLedgerList &&
                                                                                                        errors.vocherLedgerList[index] &&
                                                                                                        errors.vocherLedgerList[index].amount &&
                                                                                                        touched &&
                                                                                                        touched.vocherLedgerList &&
                                                                                                        touched.vocherLedgerList[index] &&
                                                                                                        touched.vocherLedgerList[index].amount && (
                                                                                                            <div className="field-error error text-danger">
                                                                                                                {errors.vocherLedgerList[index].amount}
                                                                                                            </div>
                                                                                                        )}

                                                                                                </td>

                                                                                                <td className="dashed-left-bottom table-inside pr-0 text-right bold-label v-lign-middle text-primary">
                                                                                                    {values?.vocherLedgerList?.length != 1 && <Tooltip title="Delete" arrow><button type="button" className="btn btn-link btn-sm text-danger" onClick={() => onDeleteClick(remove, index, selectedToLedgerListData, billRefList, amtList, billwiseDetailsArray, values, setFieldValue)}><i className="fas fa-trash"></i></button></Tooltip>}
                                                                                                    {values?.vocherLedgerList?.length == 1 && <button className="btn btn-link btn-sm text-danger" disabled><i className="fas fa-trash"></i></button>}
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    <tr className="un-border">

                                                                                    </tr>

                                                                                </tbody>
                                                                            </table>

                                                                        </div>
                                                                    </div>
                                                                </div>)
                                                            } />
                                                        <CRow className="mt-1">
                                                            <CCol md="12">
                                                                <CCard className="border-0 mb-0 card">
                                                                    <div className="card-header light-card-header pl-0 pr-0"><label className="mb-0 head-bold"><i className="fa fa-pencil"></i> Narration</label></div>
                                                                    <CCardBody className="pl-0 pr-0 pt-0 pb-2">
                                                                        <div className="input-fields">
                                                                            <textarea className="form-control" name="narration" onChange={handleChange} placeholder="Narration" rows="3" {...getFieldProps(`narration`)}></textarea>
                                                                        </div>

                                                                    </CCardBody>
                                                                </CCard>
                                                            </CCol>
                                                        </CRow>
                                                        <CRow>
                                                            <CCol md="12">
                                                                {/* <h6 className="min-font-size text-info c-pointer" onClick={() => onAdditionalModalOpen(allAdditionalDetails)}>Optional Details</h6> */}
                                                            </CCol>
                                                        </CRow>
                                                        <CRow>
                                                            <CCol md="12">
                                                                <div className="text-right mt-1">
                                                                    {/* <button className="btn btn-link mr-2 btn-sm text-dark bold-label" onClick={() => onMainModalClose()}><i className="fas fa-times"></i> Close</button> */}
                                                                    <button className="btn btn-primary btn-sm btn-shadow"><i className="fas fa-check"></i> Submit</button>
                                                                </div>
                                                            </CCol>
                                                        </CRow>
                                                    </div>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CModalBody>
                        </CModal>
                    </Form>)}
            </Formik>
            <CModal
                show={AdditionaldetailsModal}
                centered
                size="sm"
                onClose={() => onAdditionalModalClose()}
                color="dark nested-modal"
                closeOnBackdrop={true} className="left"
            >
                <CModalHeader closeButton className="p-2">
                    {/* <CModalTitle> */}
                    <div className="row">
                        <div className="col-md-12 mt-1"><h6 className="bold-label mb-0">Additional Details</h6></div>
                    </div>
                    {/* </CModalTitle> */}
                </CModalHeader>
                <CModalBody className="text-left less-modal-bold pl-3 pr-3 pt-2 pb-3 ">
                    <div className="card-style-border-top border-0 c-default-layout flex-row align-items-">
                        <div className="row">
                            <div className="col-md-12 mb-2">
                                <label className="mb-0 bold-label">Payment Mode</label>
                                <CSelect type="text" placeholder="Priority" name="paymentMode" value={paymentMode} onChange={e => setpaymentMode(e.target.value)} className="text-input-sm">
                                    <option value="-1">Select Payment Mode</option>
                                    <option value="Cheque">Cheque</option>
                                    <option value="E-fund Transfer">E-fund Transfer</option>
                                    <option value="Others">Others</option>
                                </CSelect>
                            </div>
                            <div className="col-md-12 mb-2">
                                <label className="mb-0 bold-label">Instrument No.</label>
                                <CInput type="text" placeholder="Instrument No" name="assignTo" value={insNo} onChange={e => setinsNo(e.target.value)} className="text-input-sm"></CInput>
                            </div>
                            <div className="col-md-12 mb-2">
                                <label className="mb-0 bold-label">Instrument Date</label>
                                {/* <CInput type="text" placeholder="DD/MM/YYYY" name="assignTo" value={insDate} onChange={e=>setinsDate(e.target.value)} className="text-input-sm"></CInput> */}
                                <CInputGroup className="mb-0 calendar-input d-grid">
                                    <Calendar
                                        id="range"
                                        value={insDate}
                                        // className="mr-0 form-control"
                                        onChange={e => setinsDate(e.target.value)}
                                        // onChange={(e) => onInstumentDateChange(e.value, setFieldValue)}
                                        placeholder="DD/MM/YYYY"
                                        dateFormat="dd/mm/yy"
                                        name="instumentDate"
                                    // maxDate={toDate}
                                    />
                                </CInputGroup>
                            </div>
                            <CCol md="12 mt-2">
                                <div className="text-right">
                                    <button className="btn btn-primary btn-sm btn-shadow" onClick={() => onAdditionalSave()}><i className="fas fa-check"></i> Submit</button>
                                </div>
                            </CCol>
                        </div>
                    </div>
                </CModalBody>
            </CModal>
            <Formik
                initialValues={
                    intialValues
                }
                enableReinitialize={true}
                validationSchema={validationSchemaForBreakUp}
                onSubmit={((values, errors) => {
                    onBillWiseDetailsSubmit(values, billwiseDetailsArray, billwiseDetailsArrayIndex)
                    // console.log(errors);
                })}>
                {({ handleChange, values, errors, touched, getFieldProps, handleBlur, setFieldValue, handleSubmit }) => (
                    <CModal
                        show={primary}
                        centered
                        size="lg"
                        onClose={() => onModalClose()}
                        color="dark nested-modal"
                        closeOnBackdrop={false}
                    >
                        <CModalHeader closeButton className="p-2">
                            <CModalTitle>Bill Wise Details</CModalTitle>
                        </CModalHeader>
                        <CModalBody className="text-left less-modal-bold">

                            <Form>
                                {/* <div className="row">
                                    <div className="col-md-12 text-center">
                                        <h6><span className="bold-label">Bill Wise Details for:</span> <span className="text-success">{showLederOnBillEntryModal}</span></h6>
                                        <h6><span className="bold-label">Upto:</span> <span className="text-success">{showtotalbillEntryValue}</span></h6>
                                    </div>
                                </div> */}
                                <FieldArray
                                    name="billwiseDetails"
                                    render={({ remove, push }) => (
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="text-right mb-3">
                                                    <button type="button" className="btn btn-primary btn-xs btn-shadow" onClick={() => onAddBreakUpAmounts(push, selecteddateValue)}><i className="fas fa-plus"></i> Add</button>
                                                </div>
                                                <table className="table mt-2 credit-debit-table light-td-border">
                                                    <thead className="thead-light dark-th-border">
                                                        <tr>
                                                            <th className="min-font-size" width="20%">Type of Ref</th>
                                                            <th className="min-font-size" width="25%">Name</th>
                                                            <th className="min-font-size">Due Date</th>
                                                            <th className="min-font-size">Amount</th>
                                                            <th className="min-font-size" width="12%">Dr/Cr</th>
                                                            <th className="min-font-size text-center"><i className="fas fa-hashtag"></i></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {values?.billwiseDetails?.length > 0 &&
                                                            values?.billwiseDetails.map((voucher, index) => (

                                                                <tr key={`billwiseDetails${index}`} className="">
                                                                    <td>
                                                                        <div className="form-group mb-0">
                                                                            <select className="form-control overflow-elipsis" onChange={(e) => onTypeOfRefChange(e.target.value, setFieldValue, index, intialValues)} value={values?.billwiseDetails[index].typeOfRef} name={`billwiseDetails.${index}.typeOfRef`}>
                                                                                <option value="Advance">Advance</option>
                                                                                <option value="Agst Ref">Agst Ref</option>
                                                                                <option value="New Ref">New Ref</option>
                                                                                <option value="On Account">On Account</option>
                                                                            </select>
                                                                            {errors &&
                                                                                errors.billwiseDetails &&
                                                                                errors.billwiseDetails[index] &&
                                                                                errors.billwiseDetails[index].typeOfRef &&
                                                                                touched &&
                                                                                touched.billwiseDetails &&
                                                                                touched.billwiseDetails[index] &&
                                                                                touched.billwiseDetails[index].typeOfRef && (
                                                                                    <div className="field-error error text-danger">
                                                                                        {errors.billwiseDetails[index].typeOfRef}
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="form-group mb-0">
                                                                            <input className="form-control overflow-elipsis" {...getFieldProps(`billwiseDetails.${index}.name`)} onInput={(e) => onNameInput(e.target.value, values, index, setFieldValue, selectedLedgerId)} onClick={(e) => onNameClick(values?.billwiseDetails[index].typeOfRef, index, values)} placeholder="Name" name={`billwiseDetails.${index}.name`} onChange={handleChange} onBlur={handleBlur}>
                                                                            </input>
                                                                            {errors &&
                                                                                errors.billwiseDetails &&
                                                                                errors.billwiseDetails[index] &&
                                                                                errors.billwiseDetails[index].name &&
                                                                                touched &&
                                                                                touched.billwiseDetails &&
                                                                                touched.billwiseDetails[index] &&
                                                                                touched.billwiseDetails[index].name && (
                                                                                    <div className="field-error error text-danger">
                                                                                        {errors.billwiseDetails[index].name}
                                                                                    </div>
                                                                                )}
                                                                            {errors &&
                                                                                errors.billwiseDetails &&
                                                                                errors.billwiseDetails[index] &&
                                                                                errors.billwiseDetails[index].duplicate &&
                                                                                touched &&
                                                                                touched.billwiseDetails &&
                                                                                touched.billwiseDetails[index] &&
                                                                                touched.billwiseDetails[index].duplicate && (
                                                                                    <div className="field-error error text-danger">
                                                                                        {errors.billwiseDetails[index].duplicate}
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    </td>
                                                                    <td className="">
                                                                        <div className="form-group calendar-input d-grid mb-0">
                                                                            <Calendar
                                                                                id="range"
                                                                                value={selecteddateValue[index]?.selectedDueDateValue}
                                                                                onChange={(e) => onDueDateChange(e.value, setFieldValue, index, selecteddateValue)}
                                                                                placeholder="DD/MM/YYYY"
                                                                                dateFormat="dd/mm/yy"
                                                                                name={`billwiseDetails.${index}.dueDate`}
                                                                            // {...getFieldProps(`billwiseDetails.${index}.typeOfRef`)}
                                                                            // maxDate={toDate}
                                                                            />
                                                                            {errors &&
                                                                                errors.billwiseDetails &&
                                                                                errors.billwiseDetails[index] &&
                                                                                errors.billwiseDetails[index].dueDate &&
                                                                                touched &&
                                                                                touched.billwiseDetails &&
                                                                                touched.billwiseDetails[index] &&
                                                                                touched.billwiseDetails[index].dueDate && (
                                                                                    <div className="field-error error text-danger">
                                                                                        {errors.billwiseDetails[index].dueDate}
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    </td>
                                                                    <td > <div className="form-group mb-0">
                                                                        <input className="form-control text-right" placeholder="Amount" {...getFieldProps(`billwiseDetails.${index}.amount`)} name={`billwiseDetails.${index}.amount`} onChange={handleChange} onBlur={handleBlur}>

                                                                        </input>
                                                                        {errors &&
                                                                            errors.billwiseDetails &&
                                                                            errors.billwiseDetails[index] &&
                                                                            errors.billwiseDetails[index].amount &&
                                                                            touched &&
                                                                            touched.billwiseDetails &&
                                                                            touched.billwiseDetails[index] &&
                                                                            touched.billwiseDetails[index].amount && (
                                                                                <div className="field-error error text-danger">
                                                                                    {errors.billwiseDetails[index].amount}
                                                                                </div>
                                                                            )}
                                                                    </div></td>
                                                                    <td className="">
                                                                        <select className="form-control" id="sel1" {...getFieldProps(`billwiseDetails.${index}.amountType`)} name={`billwiseDetails.${index}.amountType`} onChange={handleChange} onBlur={handleBlur}>
                                                                            <option>Dr</option>
                                                                            <option>Cr</option>
                                                                        </select>
                                                                        {errors &&
                                                                            errors.billwiseDetails &&
                                                                            errors.billwiseDetails[index] &&
                                                                            errors.billwiseDetails[index].amountType &&
                                                                            touched &&
                                                                            touched.billwiseDetails &&
                                                                            touched.billwiseDetails[index] &&
                                                                            touched.billwiseDetails[index].amountType && (
                                                                                <div className="field-error error text-danger">
                                                                                    {errors.billwiseDetails[index].amountType}
                                                                                </div>
                                                                            )}
                                                                    </td>
                                                                    <td>
                                                                        {values?.billwiseDetails?.length != 1 && <button type="button" className="btn btn-link btn-sm text-danger" onClick={() => onBraekUpDeleteClick(remove, index)}><i className="fas fa-trash"></i></button>}
                                                                        {values?.billwiseDetails?.length == 1 && <button className="btn btn-link btn-sm text-danger" disabled><i className="fas fa-trash"></i></button>}
                                                                    </td>
                                                                </tr>

                                                            ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                />
                            </Form>

                        </CModalBody>
                        <CModalFooter>
                            <button type="submit" className="btn btn-primary btn-shadow" onClick={handleSubmit}>Submit</button>
                            <CButton type="button" color="dark" className="btn-shadow" onClick={() => onModalClose()}>
                                Close
                            </CButton>
                        </CModalFooter>
                    </CModal>
                )}
            </Formik>
            <div className="right-side">
                <CModal
                    show={primaryRefModal}
                    centered
                    size="lg"
                    onClose={() => onRefModalClose()}
                    color="dark right nested-modal"
                // closeOnBackdrop={false}
                >
                    <CModalHeader closeButton className="pt-2 pb-2">
                        <CModalTitle>Pending Bills</CModalTitle>
                    </CModalHeader>
                    <CModalBody className="text-left less-modal-bold">
                        <div className="mb-3">{header()}</div>
                        <div className="light-bill-td-border">
                            <DataTable
                                value={billRefByLedger}
                                globalFilter={globalFilter}
                                paginator={billRefByLedger.length > 0}
                                emptyMessage={<EmptyMessage />}
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink  RowsPerPageDropdown"
                                // currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                rows={10}
                                onSelectionChange={(e) => onSelectData(e.value)}
                                selectionMode="single"
                            //rowsPerPageOptions={[10, 20, 50]}
                            >
                                <Column
                                    field="refNo"
                                    header="Name"
                                ></Column>
                                <Column
                                    field="balance"
                                    header="Balance"
                                ></Column>
                                <Column
                                    field="tyupe"
                                    header="Type"
                                ></Column>
                            </DataTable>
                        </div>
                    </CModalBody>
                </CModal>
            </div>
        </>
    );
};
export default PurchaseAdd;

